import axios from "./axiosService";
import CommonService from "./commonService";

class PromptLibraryService {
  commonService = new CommonService();

  constructor() {
    this.apiHostEnv = process.env.REACT_APP_HOSTING_ENV;
    this.apiEndpoint = process.env.REACT_APP_WEB_API_ENDPOINT;
    this.apiFolder = process.env.REACT_APP_PLATFORM_API_FOLDER;
    this.apiEndpointAU = process.env.REACT_APP_WEB_API_ENDPOINT_AU;
    this.apiEndpointEU = process.env.REACT_APP_WEB_API_ENDPOINT_EU;
    this.apiEndpointUS = process.env.REACT_APP_WEB_API_ENDPOINT_US;
    this.apiEndpointPlatform = process.env.REACT_APP_WEB_API_FOLDER;

    //  List of API endpoints to point to local mock data
    this.mockApiUrl = [
      // "getSystemPrompt"
    ];
  }

  async getSystemPrompt(userId) {
    const request = { userId: userId, promptType: "system" };
    const apiUrl = this.apiEndpoint + this.apiFolder;
    const response = await axios
      .post(apiUrl + "/fetchSystemPrompts", request)
      .catch((reason) => {
        this.commonService.logException(
          reason,
          "PromptLibraryService",
          "getSystemPrompt"
        );
      });
    return response?.data;
  }

  async getTableTypes(payload) {
    const apiUrl = this.apiEndpoint + this.apiEndpointPlatform;
    try {
      const response = await axios.get(
        apiUrl + "/Platform/GetProjectScopeAPIList",
        { params: payload }
      );
      return response.data;
    } catch (error) {
      this.commonService.logException(
        error,
        "PromptLibraryService",
        "getTableTypes"
      );
      return null;
    }
  }

  getPersonalPrompts = async (userId) => {
    const request = { userId: userId, promptType: "personal" };
    const apiUrl = this.apiEndpoint + this.apiFolder;
    const response = await axios
      .post(apiUrl + "/fetchCentralpPrompts", request)
      .catch((reason) => {
        this.commonService.logException(
          reason,
          "PromptLibraryService",
          "getPersonalPrompts"
        );
      });
    return response?.data;
  };

  getPersonalPrompt = async (payload) => {
    const apiUrl = this.apiEndpoint + this.apiFolder;
    const response = await axios
      .post(apiUrl + "/getPrompts", payload)
      .catch((reason) => {
        this.commonService.logException(
          reason,
          "PromptLibraryService",
          "getPersonalPrompt"
        );
      });
    return response?.data;
  };

  async getCentralPrompt(payload) {
    const apiUrl = this.apiEndpoint + this.apiEndpointPlatform;
    try {
      const response = await axios.get(apiUrl + "/Platform/GetSystemPrompts", {
        params: payload,
      });
      return response?.data;
    } catch (error) {
      this.commonService.logException(
        error,
        "PromptLibraryService",
        "getCentralPrompt"
      );
      return null;
    }
  }

  savePersonalPrompt = async (payload) => {
    try {
      if (this.apiHostEnv === "UAT" || this.apiHostEnv === "PROD") {
        const apiUrlAU = this.apiEndpointAU + this.apiFolder;
        const apiUrlEU = this.apiEndpointEU + this.apiFolder;
        const apiUrlUS = this.apiEndpointUS + this.apiFolder;
        const resAU = await axios
          .post(apiUrlAU + "/editPersonalPrompts", payload)
          .then((response) => response)
          .catch(() => null);
        const resEU = await axios
          .post(apiUrlEU + "/editPersonalPrompts", payload)
          .then((response) => response)
          .catch(() => null);
        const resUS = await axios
          .post(apiUrlUS + "/editPersonalPrompts", payload)
          .then((response) => response)
          .catch(() => null);
        return resAU || resEU || resUS;
      } else {
        const apiUrl = this.apiEndpoint + this.apiFolder;
        const res = await axios
          .post(apiUrl + "/editPersonalPrompts", payload)
          .then((response) => response)
          .catch(() => null);
        return res;
      }
    } catch (error) {
      this.commonService.logException(
        error,
        "PromptLibraryService",
        "savePersonalPrompt"
      );
    }
  };

  saveCentralPrompt = async (payload) => {
    try {
      if (this.apiHostEnv === "UAT" || this.apiHostEnv === "PROD") {
        const apiUrlAU = this.apiEndpointAU + this.apiFolder;
        const apiUrlEU = this.apiEndpointEU + this.apiFolder;
        const apiUrlUS = this.apiEndpointUS + this.apiFolder;
        const resAU = await axios
          .post(apiUrlAU + "/EditCentralPrompt", payload)
          .then((response) => response)
          .catch(() => null);
        const resEU = await axios
          .post(apiUrlEU + "/EditCentralPrompt", payload)
          .then((response) => response)
          .catch(() => null);
        const resUS = await axios
          .post(apiUrlUS + "/EditCentralPrompt", payload)
          .then((response) => response)
          .catch(() => null);
        return resAU || resEU || resUS;
      } else {
        const apiUrl = this.apiEndpoint + this.apiFolder;
        const res = await axios
          .post(apiUrl + "/EditCentralPrompt", payload)
          .then((response) => response)
          .catch(() => null);
        return res;
      }
    } catch (error) {
      this.commonService.logException(
        error,
        "PromptLibraryService",
        "saveCentralPrompt"
      );
    }
  };

  deletePersonalPrompt = async (payload) => {
    try {
      if (this.apiHostEnv === "UAT" || this.apiHostEnv === "PROD") {
        const apiUrlAU = this.apiEndpointAU + this.apiFolder;
        const apiUrlEU = this.apiEndpointEU + this.apiFolder;
        const apiUrlUS = this.apiEndpointUS + this.apiFolder;
        const resAU = await axios
          .post(apiUrlAU + "/deletePersonalPrompts", payload)
          .then((response) => response)
          .catch(() => null);
        const resEU = await axios
          .post(apiUrlEU + "/deletePersonalPrompts", payload)
          .then((response) => response)
          .catch(() => null);
        const resUS = await axios
          .post(apiUrlUS + "/deletePersonalPrompts", payload)
          .then((response) => response)
          .catch(() => null);
        return resAU || resEU || resUS;
      } else {
        const apiUrl = this.apiEndpoint + this.apiFolder;
        const res = await axios
          .post(apiUrl + "/deletePersonalPrompts", payload)
          .then((response) => response)
          .catch(() => null);
        return res;
      }
    } catch (error) {
      this.commonService.logException(
        error,
        "PromptLibraryService",
        "deletePersonalPrompt"
      );
    }
  };

  addPersonalPrompt = async (payload) => {
    try {
      if (this.apiHostEnv === "UAT" || this.apiHostEnv === "PROD") {
        const apiUrlAU = this.apiEndpointAU + this.apiFolder;
        const apiUrlEU = this.apiEndpointEU + this.apiFolder;
        const apiUrlUS = this.apiEndpointUS + this.apiFolder;
        const resAU = await axios
          .post(apiUrlAU + "/RoleBasedAddPrompt", payload)
          .then((response) => response)
          .catch(() => null);
        const resEU = await axios
          .post(apiUrlEU + "/RoleBasedAddPrompt", payload)
          .then((response) => response)
          .catch(() => null);
        const resUS = await axios
          .post(apiUrlUS + "/RoleBasedAddPrompt", payload)
          .then((response) => response)
          .catch(() => null);
        return resAU || resEU || resUS;
      } else {
        const apiUrl = this.apiEndpoint + this.apiFolder;
        const res = await axios
          .post(apiUrl + "/RoleBasedAddPrompt", payload)
          .then((response) => response)
          .catch(() => null);
        return res;
      }
    } catch (error) {
      this.commonService.logException(
        error,
        "PromptLibraryService",
        "addPersonalPrompt"
      );
    }
  };

  addCentralPrompt = async (payload) => {
    try {
      if (this.apiHostEnv === "UAT" || this.apiHostEnv === "PROD") {
        const apiUrlAU = this.apiEndpointAU + this.apiFolder;
        const apiUrlEU = this.apiEndpointEU + this.apiFolder;
        const apiUrlUS = this.apiEndpointUS + this.apiFolder;
        const resAU = await axios
          .post(apiUrlAU + "/RoleBasedAddPrompt", payload)
          .then((response) => response)
          .catch(() => null);
        const resEU = await axios
          .post(apiUrlEU + "/RoleBasedAddPrompt", payload)
          .then((response) => response)
          .catch(() => null);
        const resUS = await axios
          .post(apiUrlUS + "/RoleBasedAddPrompt", payload)
          .then((response) => response)
          .catch(() => null);
        return resAU || resEU || resUS;
      } else {
        const apiUrl = this.apiEndpoint + this.apiFolder;
        const res = await axios
          .post(apiUrl + "/RoleBasedAddPrompt", payload)
          .then((response) => response)
          .catch(() => null);
        return res;
      }
    } catch (error) {
      this.commonService.logException(
        error,
        "PromptLibraryService",
        "addCentralPrompt"
      );
    }
  };

  copyCentralPromptToPersonal = async (payload) => {
    try {
      if (this.apiHostEnv === "UAT" || this.apiHostEnv === "PROD") {
        const apiUrlAU = this.apiEndpointAU + this.apiFolder;
        const apiUrlEU = this.apiEndpointEU + this.apiFolder;
        const apiUrlUS = this.apiEndpointUS + this.apiFolder;
        const resAU = await axios
          .post(apiUrlAU + "/CopyPromptToPersonal", payload)
          .then((response) => response)
          .catch(() => null);
        const resEU = await axios
          .post(apiUrlEU + "/CopyPromptToPersonal", payload)
          .then((response) => response)
          .catch(() => null);
        const resUS = await axios
          .post(apiUrlUS + "/CopyPromptToPersonal", payload)
          .then((response) => response)
          .catch(() => null);
        return resAU || resEU || resUS;
      } else {
        const apiUrl = this.apiEndpoint + this.apiFolder;
        const res = await axios
          .post(apiUrl + "/CopyPromptToPersonal", payload)
          .then((response) => response)
          .catch(() => null);
        return res;
      }
    } catch (error) {
      this.commonService.logException(
        error,
        "PromptLibraryService",
        "copyCentralPromptToPersonal"
      );
    }
  };

  saveSystemPrompt = async (payload) => {
    try {
      if (this.apiHostEnv === "UAT" || this.apiHostEnv === "PROD") {
        const apiUrlAU = this.apiEndpointAU + this.apiFolder;
        const apiUrlEU = this.apiEndpointEU + this.apiFolder;
        const apiUrlUS = this.apiEndpointUS + this.apiFolder;
        const resAU = await axios
          .post(apiUrlAU + "/editSystemPrompts", payload)
          .then((response) => response)
          .catch(() => null);
        const resEU = await axios
          .post(apiUrlEU + "/editSystemPrompts", payload)
          .then((response) => response)
          .catch(() => null);
        const resUS = await axios
          .post(apiUrlUS + "/editSystemPrompts", payload)
          .then((response) => response)
          .catch(() => null);
        return resAU || resEU || resUS;
      } else {
        const apiUrl = this.apiEndpoint + this.apiFolder;
        const res = await axios
          .post(apiUrl + "/editSystemPrompts", payload)
          .then((response) => response)
          .catch(() => null);
        return res;
      }
    } catch (error) {
      this.commonService.logException(
        error,
        "PromptLibraryService",
        "saveSystemPrompt"
      );
    }
  };
}

export default PromptLibraryService;
